import {
  convertExerciseDraftToFormik,
  convertFormikToExerciseDraft,
  ExerciseFormikType,
  getExerciseBlockValidationSchema,
} from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { getMediaBlockValidationSchema, MediaFormikType } from "@modules/sessionBlock/media/mediaFormikTypes"
import {
  AthleteNoteFormikType,
  CoachNoteFormikType,
  getAthleteNoteBlockValidationSchema,
  getCoachNoteBlockValidationSchema,
} from "@modules/sessionBlock/notes/noteFormikTypes"
import { SessionBlockDraft, SessionBlockType } from "@modules/sessionBlock/sessionBlockTypes"
import * as Yup from "yup"

export type SessionBlockInputKey = "content" | "type" | "url"

export type SessionBlockExerciseFormikType = {
  type: SessionBlockType.SESSION_EXERCISE
  content: ExerciseFormikType
}
export type SessionBlockCoachNoteFormikType = {
  type: SessionBlockType.COACH_NOTE
  content: CoachNoteFormikType
}
export type SessionBlockAthleteNoteFormikType = {
  type: SessionBlockType.ATHLETE_NOTE
  content: AthleteNoteFormikType
}
export type SessionBlockMediasFormikType = {
  type: SessionBlockType.MEDIAS
  content: MediaFormikType
}

export type SessionBlockFormikType =
  | SessionBlockExerciseFormikType
  | SessionBlockCoachNoteFormikType
  | SessionBlockAthleteNoteFormikType
  | SessionBlockMediasFormikType

export function getSessionBlockValidationSchema() {
  return Yup.object().shape({
    type: Yup.string().oneOf(Object.values(SessionBlockType)),
    content: Yup.object().when("type", (type) => {
      return type[0] === SessionBlockType.SESSION_EXERCISE
        ? getExerciseBlockValidationSchema()
        : type[0] === SessionBlockType.COACH_NOTE
          ? getCoachNoteBlockValidationSchema()
          : type[0] === SessionBlockType.ATHLETE_NOTE
            ? getAthleteNoteBlockValidationSchema()
            : getMediaBlockValidationSchema()
    }),
  })
}

export const convertSessionBlockDraftToFormik = (blockDraft: SessionBlockDraft): SessionBlockFormikType => {
  if (blockDraft.type === SessionBlockType.SESSION_EXERCISE)
    return {
      type: blockDraft.type,
      content: convertExerciseDraftToFormik(blockDraft.content),
    }
  else if (blockDraft.type === SessionBlockType.ATHLETE_NOTE)
    return {
      type: blockDraft.type,
      content: blockDraft.content,
    }
  else if (blockDraft.type === SessionBlockType.COACH_NOTE)
    return {
      type: blockDraft.type,
      content: blockDraft.content,
    }
  else
    return {
      type: blockDraft.type,
      content: blockDraft.content,
    }
}

export const convertFormikToSessionBlockDraft = (blockFormik: SessionBlockFormikType): SessionBlockDraft => {
  if (blockFormik.type === SessionBlockType.SESSION_EXERCISE) {
    return {
      type: blockFormik.type,
      content: convertFormikToExerciseDraft(blockFormik.content),
    }
  } else if (blockFormik.type === SessionBlockType.COACH_NOTE) {
    return {
      type: blockFormik.type,
      content: blockFormik.content,
    }
  } else if (blockFormik.type === SessionBlockType.ATHLETE_NOTE) {
    return {
      type: blockFormik.type,
      content: blockFormik.content,
    }
  } else
    return {
      type: blockFormik.type,
      content: {
        medias: blockFormik.content.medias.map((media) => ({
          id: !!media.id && media.id !== "" ? media.id : undefined,
          url: !!media.url && media.url !== "" ? media.url : undefined,
          awsS3Key: media.awsS3Key,
          type: media.type,
          filename: media.filename ?? null,
        })),
      },
    }
}
